<div
  class="ripple-container"
  [class.disabled]="!isNotDisabled"
  [matRippleDisabled]="!isNotDisabled"
  matRipple
>
  <mat-icon data-cy="batch-toolbar-submit-hiring-manager-review">description
  </mat-icon>
  Submit to Hiring Manager
</div>
